exports = module.exports = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner[data-v-1916136d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  font-size: 14px;\n  padding: 12px;\n  color: black;\n  font-weight: bold;\n}\n.inner .label[data-v-1916136d] {\n    padding-left: 20px;\n    max-width: 60%;\n    word-wrap: break-word;\n}\n.inner .value[data-v-1916136d] {\n    width: 40%;\n}\n", ""]);

// exports
